import { render, staticRenderFns } from "./BahiasForm.vue?vue&type=template&id=3f2b7df2&scoped=true"
import script from "./BahiasForm.vue?vue&type=script&lang=js"
export * from "./BahiasForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2b7df2",
  null
  
)

export default component.exports